<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true"
        @refresh="onRefresh" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
                @click="onClickAggiornaTariffe">
                <b-icon icon="plus"></b-icon>
                Aggiorna Elenco Tariffe
            </b-button>
            <b-button class="float-sm-right" variant="purple btn-toolbar sa-margin-right" size="sm"
                @click="onClickTornaListaPrestazioni">
                <b-icon icon="arrow-left"></b-icon>
                Torna a Lista Prestazioni
            </b-button>
            <!-- <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
                @click="onClickNuovoTipoImpegnativa">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button> -->
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row class="text-center" align-h="center" align-v="center">
                    <b-col cols="12" class="sa-badge-wrapper">
                        <div :class="{ 'sa-badge': true }" style="width: 100%">
                            <b-row>
                                <b-col cols="12">
                                    <span class="sa-badge-label">Quota e Percentuale Asl:
                                        <b>{{ prestazione.quotaAsl + "$" }} - {{ prestazione.percentualeAsl + "%"
                                            }}</b>
                                    </span>
                                </b-col>
                                <b-col cols="12">
                                    <span class="sa-badge-label">Importo:
                                        <b>{{ "€ " + prestazione.importo }}</b>
                                    </span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" style="margin-bottom: 5px">
                        <label class="sa-label-data">Data Riferimento</label>
                        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="filter.dataRiferimento"
                            type="date"></date-picker>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <RsaConfigurazioneAggiornamentoTariffaListComponent ref="RsaConfigurazioneAggiornamentoTariffaListComponent"
                @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneAggiornamentoTariffaListComponent from "../components/RsaConfigurazioneAggiornamentoTariffaListComponent.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    components: { SaPageLayout, RsaConfigurazioneAggiornamentoTariffaListComponent, DatePicker },
    mixins: [UtilityMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            filter: {
                dataRiferimento: new Date().getTime(),
                codicePrestazione: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            pathResourcePrestazioni: "/rsatipoprestazioni",
            linkConfigurazioni: "/configurazioni",
            prestazione: {
                nome: "Alto Livello (disabili gravi) DISABILI - RD3",
                codicePrestazione: "codice",
                quotaAsl: 96.43,
                note: null,
                percentualeAsl: "0",
            },
        };
    },
    mounted() {
        let me = this;
        this.id = this.$route.params.id;
        me.loadDataPrestazioneImpegnativa();
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroTariffaImpegnativa"]) {
            me.filter = JSON.parse(sessionStorage["filtroTariffaImpegnativa"]);
        }
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.RsaConfigurazioneAggiornamentoTariffaListComponent.loadData();
        },
        onBeforeLoadData() {
            this.showModalLoading = true;
        },
        onAfterLoadData() {
            this.showModalLoading = false;
        },

        loadDataPrestazioneImpegnativa() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePrestazioni + "/" + this.id, null, me.loadDataPrestazioneImpegnativaSuccess, me.loadDataPrestazioneImpegnativaError);
        },
        loadDataPrestazioneImpegnativaSuccess(response) {
            let me = this;
            console.log(response);
            this.prestazione = response.data.data;
            this.filter.codicePrestazione = this.prestazione.codicePrestazione;
            sessionStorage["filtroTariffaImpegnativa"] = JSON.stringify(me.filter);
            me.loadData();
            me.$emit("afterLoadData");
        },
        loadDataPrestazioneImpegnativaError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.$emit("afterLoadData");
        },

        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroTariffaImpegnativa"] = JSON.stringify(me.filter);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },

        onClickTornaListaPrestazioni() {
            this.$router.push("/configurazioni/rsatipoprestazioni");
        },
        onClickAggiornaTariffe() {
            console.log("todo");
        },
    },
};
</script>
<style scoped>
.card-body {
    border-radius: 3px;
    border-left: 2px solid var(--bg-sidebar);
    border-top: 1px solid var(--bg-main-nav-bar);
    border-bottom: 1px solid var(--bg-main-nav-bar);
    border-right: 1px solid var(--bg-main-nav-bar);
    padding: 7px !important;
}

.sa-badge-wrapper {
    text-align: center;
    justify-content: center;
    display: flex;
    margin-top: 8px;
}

.sa-badge {
    width: 70% !important;
}
</style>
